// extracted by mini-css-extract-plugin
export default {"address":"_7l98Qmhs5JSfVEqR1FeGpw=="};